import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { VIEW, EDIT, MULTIPLE } from "const"
import { ccCompliantItemsRoute } from "client/parts/routes"
import { hasAccess, hasProjectAccess, forceRerenderContent } from "client/utils"
import {
    PRM_CC_LIBRARY,
    StoreType,
    IsOwnerCcLibrarySet,
    IsOwnerCcLibraryItem,
    addModal,
    closeModal,
    LangType,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    DivInput,
    Textarea,
    UserIcon,
    Button,
} from "client/components"

const Form = () => {
    const baseRoute = useSelector((state: StoreType) => state.ccLibrarySet.baseRoute)

    const item = useSelector((state: StoreType) => state.ccLibraryItem.itemView)
    const set = useSelector((state: StoreType) => state.ccLibrarySet.setView)
    const project = useSelector((state: StoreType) => state.project.projectView)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const accountList = useSelector((state: StoreType) => state.account.accountList)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const modals = useSelector((state: StoreType) => state.system.modals)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const viewSetRoute = `${baseRoute}/${VIEW}/${set.id}`
    const editItemUrl = `${viewSetRoute}${ccCompliantItemsRoute}/${EDIT}/${item.id}`

    const editAccess = !project.id
        ? hasAccess(PRM_CC_LIBRARY, EDIT)
        : hasProjectAccess(PRM_CC_LIBRARY, EDIT)

    const isSetOwner = IsOwnerCcLibrarySet(project.id, set, userData)
    const isItemOwner = IsOwnerCcLibraryItem(project.id, item, userData)

    const allowedToEdit = editAccess || isSetOwner || isItemOwner

    const creator = item.creator && userList[item.creator]
    const ownerAccount = item.accountId && accountList[item.accountId]
    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.publicId}</Label>
                        <Input type="text" value={item.publicId} readOnly />
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.compliantItem}</Label>
                        <Textarea value={item.compliantItem} readOnly />
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.interpretation}</Label>
                        <Textarea value={item.interpretation} readOnly />
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.original}</Label>
                        <Textarea value={item.original} readOnly />
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.note}</Label>
                        <Textarea value={item.note} readOnly />
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.creator}</Label>
                        {
                            !project.id && (
                                item.accountId === userData.accountId
                                    ? <DivInput><UserIcon user={creator} size="sm" /></DivInput>
                                    : <Input type="text" value={ownerAccount ? ownerAccount.name : ""} readOnly />
                            )
                        }
                        {
                            project.id && (
                                item.projectId === project.id
                                    ? <DivInput><UserIcon user={creator} size="sm" /></DivInput>
                                    : <Input type="text" value={ownerAccount ? ownerAccount.name : ""} readOnly />
                            )
                        }
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.answerType}</Label>
                        <Input type="text" value={lang[item.answerType as keyof LangType]} readOnly />
                    </FormGroup>
                    {
                        item.answerType === MULTIPLE && (
                            <FormGroup>
                                <Label>{lang.options}</Label>
                                <Textarea value={item.options} readOnly />
                            </FormGroup>
                        )
                    }
                    <FormGroup>
                        <Label>{lang.group}</Label>
                        <Input type="text" value={item.group || ""} readOnly />
                    </FormGroup>
                </Col>
                <Col xs={12}>
                    {
                        allowedToEdit && (
                            <Button row onClick={() => dispatch(addModal({ url: editItemUrl }))}>
                                {lang.edit}
                            </Button>
                        )
                    }
                    <Button
                        row
                        onClick={() => {
                            if (modals.length) {
                                dispatch(closeModal())
                                return
                            }
                            forceRerenderContent(viewSetRoute, dispatch)
                        }}
                    >
                        {lang.close}
                    </Button>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
